module.exports = __webpack_public_path__ + "static/media/id4-carlos_sa-full.d0d3a742.jpg";